// removed by extract-text-webpack-plugin
module.exports = {"pos":"style__pos-1JGHQ","headerWrap":"style__headerWrap-1cusG","wrap":"style__wrap-35875","logo":"style__logo-yXZd-","menu":"style__menu-xPA5r","menuItem":"style__menuItem-1gN8B"};


//////////////////
// WEBPACK FOOTER
// ./src/views/MainLayout/HeaderBar/style.less
// module id = 633
// module chunks = 17